/* eslint-disable jsx-a11y/alt-text */
import { mask } from "../assets";

const Cardoverlay3 = params => {

  return (
    <>
    <div  className="modal fade" id="cardOverlay2" tabIndex="-1" aria-labelledby="cardOverlayModalLabel" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-body">

            <div className="backcardlay">
              <div className="container">
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <div className="card overlay-card ">
                    <header className="overlay-header"></header>
                    <div className="text-center mt-5">
                      <h3 className="mt-4 w-63 m-auto mobile-cards-font memphis-medium color-mistake-pay">Your boss asks you to change your hours, but you can't get childcare on late notice.</h3>
                    </div>
                    <div className="text-center mt-4 ">
                      <h5 className="text-center overlay-green mt-3 Pacifico-Regulars">lose <img src={mask} className="width-set-lay" /> work/job</h5>
                    </div>
                    <div className="mt-4">
                      <footer className="overlay-footer">
                        <div className="heath-bottom-footer">
                          <h6 className="text-right text-white mr-3 health-bootom-over font-economy memphis-medium">  &copy;<span className="ml-1">Health Economy 2019</span></h6>
                        </div>
                      </footer>
                    </div>
                  </div>
                </div>
              </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Cardoverlay3;
